import { Component } from '@angular/core';
import { NavParams, ToastController, ViewController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import { TranslateService } from '@ngx-translate/core';
import { CartaServices } from '../../../carta/services';
import { AnalyticsServices } from '../../../services/analyticsServices';
import { MenuServices } from '../../../menu/services';
import { OdsServices } from '../../../ods/services';

/**
 * Component que devuelve un datetime segun lugar (espana - usa)
 *
 */

@Component({
  selector: 'create-dish',
  templateUrl: 'create-dish.html',
})
export class CompCreateDishPage {
  price: number = 0;
  name: string = '';
  allergens = [
    {
      name: this.translate.instant('general-allergens-altramueces'),
      src: './assets/icons_100/tramusos_100.png',
      uid: '2L9I1OFi0MttudVUajCy',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-apio'),
      src: './assets/icons_100/api_100.png',
      uid: 'G3bZpwrVP9bJvlOHT6XE',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-moluscos'),
      src: './assets/icons_100/molusc_100.png',
      uid: 'l1ojIaGuVlnyWjFD6WNQ',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-sesamo'),
      src: './assets/icons_100/sesam_100.png',
      uid: 'e8v2RnYzGWTH1CboyCR7',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-gluten'),
      src: './assets/icons_100/gluten_100.png',
      uid: '50bkEzjuWbQGCB7IjrEf',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-pescado'),
      src: './assets/icons_100/peix_100.png',
      uid: 'H4W23Lv4XHx4qpZCEbYN',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-dioxido-azufre-sulfitos'),
      src: './assets/icons_100/sulfits_100.png',
      uid: 'YGkIQKw7yOfwtHq95aly',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-mostaza'),
      src: './assets/icons_100/mostassa_100.png',
      uid: 'hPrDu9pjQmqXBnoxBfet',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-crustaceos'),
      src: './assets/icons_100/crustacis_100.png',
      uid: '4VuKpxSZoGRzvNqEdIlu',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-lactosa'),
      src: './assets/icons_100/lactic_100.png',
      uid: 'Io13IxX1i5BnOpjoyZBF',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-huevo'),
      src: './assets/icons_100/ou_100.png',
      uid: '1SlpPqFfsmjec4ZnwK45',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-soja'),
      src: './assets/icons_100/soja_100.png',
      uid: 'JV8kqxMaSd1Q61cwzU9x',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-frutos-secos'),
      src: './assets/icons_100/fruitsec_100.png',
      uid: '4sKpCjitEY6sV3BhwdLq',
      active: false
    },
    {
      name: this.translate.instant('general-allergens-cacahuetes'),
      src: './assets/icons_100/cacauet_100.png',
      uid: 'TRku0ZmxtpB3M73D8wlD',
      active: false
    },
    //indicators
    {
      name: this.translate.instant('general-indicators-vegano'),
      src: './assets/icons_100/vega_100.png',
      uid: 'WBDYCZPjlBWlXG772MLZ',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-vegetariano'),
      src: './assets/icons_100/vegetaria_100.png',
      uid: 'VxAwcxVQu7ZytAunh4pK',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-ecologico'),
      src: './assets/icons_100/eco_100.png',
      uid: 'axhqvt8l5LAG1jba2Heq',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-mediterraneo'),
      src: './assets/icons_100/mediterrani.png',
      uid: 'qOJouJQSVIEFLGdEkwRs',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-kosher'),
      src: './assets/icons_100/kosher_100.png',
      uid: 'ecE19RgQX1ze3CHY1XJi',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-cafeina'),
      src: './assets/icons_100/cafeina_100.png',
      uid: 'mGYwKe2JYwTICu7N7sC6',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-sin-azucar'),
      src: './assets/icons_100/sensesucre.png',
      uid: 'QVZO1ivcXi8gQp5o8XZf',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-stevia'),
      src: './assets/icons_100/stevia.png',
      uid: 'WMZCNDQNjlICEQ1CZzbF',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-halal'),
      src: './assets/icons_100/halal_100.png',
      uid: 'q05pas64NVItzqNNq1Nb',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-picante-suave'),
      src: './assets/icons_100/picant1.png',
      uid: 'PAhaRzeD1Fc8Eh9HurEU',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-picante'),
      src: './assets/icons_100/picant2.png',
      uid: 'SDwqJGfd8tGgWVjQnlHK',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-muy-picante'),
      src: './assets/icons_100/picant3.png',
      uid: 'kbTVLXJAOEPY4PNSgA1D',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-km0'),
      src: './assets/icons_100/km0.png',
      uid: 'FHdPZ4t2S4PjB0IlCnC5',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-comida-rapida'),
      src: './assets/icons_100/rapid.png',
      uid: 'NL0JHSeK2E4ZA9yLvzAB',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-recomendado'),
      src: './assets/icons_100/recomenat.png',
      uid: 'juWdKnYZliS2eNez9Geo',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-cerdo'),
      src: './assets/icons_100/porc_100.png',
      uid: 'jjVvcvGn3gLcMqXy4wKX',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-maiz'),
      src: './assets/icons_100/bmoro_100.png',
      uid: 'SGflJYVDgHRjeItCdim2',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-setas'),
      src: './assets/icons_100/bolets_100.png',
      uid: '6QYpvI63JK4XDqsz1995',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-alcohol'),
      src: './assets/icons_100/alcohol_100.png',
      uid: '04rgCKokhvB0BuwdWet5',
      active: false
    },
    {
      name: this.translate.instant('general-indicators-infantil'),
      src: './assets/icons_100/infantil_100.png',
      uid: 'x0gEJ4cFaVKLaQwfybrQ',
      active: false
    }
  ];
  origin: string;
  show_tags = false;
  tags_filtered = [];
  selected_tag: string = '';
  currentPage: number = 1; // 1 = básico, 2 = categorías

  constructor(public dishServices: DishServices,
    public globals: Globals,
    public viewCtrl: ViewController,
    public translate: TranslateService,
    private toastCtrl: ToastController,
    public cartaServices: CartaServices,
    public navParams: NavParams,
    public analyticsServices: AnalyticsServices,
    public menuServices: MenuServices,
    private odsServices: OdsServices) {
    this.origin = this.navParams.get('origin');
    // Inicializar dish_tags si no está inicializado
    if (!this.dishServices.dish_tags) {
      this.dishServices.dish_tags = [];
    }
  }

  close() {
    this.viewCtrl.dismiss();
  }

  saveElement() {
    //Comprovamos que tenga precio y nombre
    if ((this.price != null && this.price != undefined) && this.name != '') {
      //Creamos el plato y guardamos en bbdd
      this.insertDish();
      //Lo añadimos a la array de platos seleccionados
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-completa-datos-continuar'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }

  activeAllergen(allergen) {
    allergen.active = !allergen.active;
  }

  allergensCss(active) {
    if (active) {
      let cssClasses = {
        'allergenSelected': true,
        'mr-1': true,
        'mb-2': true,
      }
      return cssClasses;
    } else {
      let cssClasses = {
        'allergenSelected': false,
        'mr-1': true,
        'mb-2': true,
      }
      return cssClasses;
    }
  }

  addTag(tag) {
    // Asegurar que dish_tags sea un array
    if (!this.dishServices.dish_tags) {
      this.dishServices.dish_tags = [];
    }
    
    if (!(this.dishServices.dish_tags.indexOf(tag) > -1)) {
      if (tag != 'eti') {
        this.dishServices.dish_tags.push(tag);
        // Forzar la detección de cambios en el array
        this.dishServices.dish_tags = [...this.dishServices.dish_tags];
      }
    }
  }

  onChange(val) {
    this.dishServices.dish_tags = val || [];
  }

  onInputChange(event: any) {
    const valorInput = event.target.value;
    if (valorInput) {
      this.show_tags = true;
      this.tags_filtered = this.globals.tags_all.filter(tag =>
        tag.toLowerCase().includes(valorInput.toLowerCase()));
      this.tags_filtered.sort((one, two) => (one.toLowerCase() < two.toLowerCase() ? -1 : 1));
    } else {
      this.show_tags = false;
      this.tags_filtered = [];
    }
  }

  onSelectTagChange(event: any) {
    const selectedValue = event.target.value;
    if (selectedValue && selectedValue !== '') {
      this.addTag(selectedValue);
      // Resetear el select a la opción por defecto
      this.selected_tag = '';
    }
  }

  changePage(page: number) {
    this.currentPage = page;
  }

  nextPage() {
    this.currentPage = 2;
  }

  previousPage() {
    this.currentPage = 1;
  }

  insertDish() {
    let active_allergens = this.allergens.filter(x => x.active == true);
    let _allergens = [];
    active_allergens.forEach(allergen => {
      _allergens.push(allergen.uid);
    });
    let _dish = {
      'UID_RESTAURANT': this.globals.restaurant_uid,
      'name_es': this.name,
      'name_en': this.name,
      'name_fr': this.name,
      'name_it': this.name,
      'name_de': this.name,
      'name_ca': this.name,
      'description_es': '',
      'description_en': '',
      'description_fr': '',
      'description_it': '',
      'description_de': '',
      'description_ca': '',
      'tags': [],
      'tags_static': '',
      'foodcost_static': 0,
      'foodcost_parts': 1,
      'price': this.price,
      'price_half': 0,
      'price_tapa': 0,
      'price_combo_extra': 0,
      'price_supplement': 0,
      'price_takeaway': 0,
      'foodcost': Array(),
      'tax': this.globals.RESTAURANT_TAX,
      'allergens': _allergens,
      'image': '',
      'favourite': false,
      'tpv_active': true,
      'type_unit': 'ud',
      'created_at': new Date(),
      'updated_at': new Date(),
    };
    if (this.origin === 'ods') {
      _dish.price_takeaway = _dish.price;
    } else if (this.origin === 'combo') {
      _dish.price_combo_extra = _dish.price;
    }
    this.dishServices.afs.collection('dish').add(_dish).then(doc => {
      // Añadir tags nuevos al array global
      if (_dish.tags && _dish.tags.length > 0) {
        this.globals.addTagsToGlobal(_dish.tags);
      }
      this.dishServices.dish_tags = null;
      this.globals.GAtrackView('Dish', 'Dish - Name - Create', this.globals.restaurant.email, 'Create/Update', 'Create name', 'Dish', this.name);
      this.analyticsServices.trackingExp('crear plato', this.globals.tracking_exp['create_element'], '');
      //
      if (this.origin === 'carta') {
        this.insertToCarta(_dish, doc.id);
        this.close();
      } else if (this.origin === 'menu') {
        this.insertToMenu(_dish, doc.id);
        this.close();
      } else if (this.origin === 'combo') {
        this.insertToCombo(_dish, doc.id);
        this.close();
      } else if (this.origin == 'variations') {
        this.selectToCreateVariation(_dish, doc.id);
      } else {
        this.insertToCartaTK(_dish, doc.id);
        this.close();
      }
    });
  }

  insertToCarta(element, element_uid) {
    element.UID = element_uid;
    element.name = element.name_es;
    element.type = 'dish';
    //Funcion que añadir al array de platos seleccionados para el menu
    var _array = Array();

    _array.push(element_uid); //UID
    _array.push(this.cartaServices.carta_dish_prod_array_tmp.length + 1); //Order
    _array.push('dish');
    if (element.name_es != undefined) {
      _array.push(element.name_es);
    } else {
      _array.push('');
    }
    if (element.name_ca != undefined) {
      _array.push(element.name_ca);
    } else {
      _array.push('');
    }
    if (element.name_en != undefined) {
      _array.push(element.name_en);
    } else {
      _array.push('');
    }
    if (element.name_de != undefined) {
      _array.push(element.name_de);
    } else {
      _array.push('');
    }
    if (element.name_fr != undefined) {
      _array.push(element.name_fr);
    } else {
      _array.push('');
    }
    if (element.name_it != undefined) {
      _array.push(element.name_it);
    } else {
      _array.push('');
    }
    _array.push(element.allergens);
    _array.push(element.price);
    _array.push(element.price_half);
    _array.push(element.price_tapa);
    _array.push(element.foodcost_static / element.foodcost_parts);
    if (element.image != undefined) {
      _array.push(element.image);
    } else {
      _array.push('');
    }
    if (element.description_es != undefined) {
      _array.push(element.description_es);
    } else {
      _array.push('');
    }
    if (element.description_ca != undefined) {
      _array.push(element.description_ca);
    } else {
      _array.push('');
    }
    if (element.description_en != undefined) {
      _array.push(element.description_en);
    } else {
      _array.push('');
    }
    if (element.description_de != undefined) {
      _array.push(element.description_de);
    } else {
      _array.push('');
    }
    if (element.description_fr != undefined) {
      _array.push(element.description_fr);
    } else {
      _array.push('');
    }
    if (element.description_it != undefined) {
      _array.push(element.description_it);
    } else {
      _array.push('');
    }
    if (element.tags != undefined) {
      _array.push(element.tags);
    } else {
      _array.push([]);
    }
    if (element.price_takeaway != undefined) {
      _array.push(element.price_takeaway);
    } else {
      _array.push('');
    }
    if (element.tk_active == undefined || element.tk_active) {
      _array.push(true);
    } else {
      _array.push(false);
    }
    if (element.featured) {
      _array.push(true);
    } else {
      _array.push(false);
    }
    if (element.tk_pickup_day) {
      _array.push(element.tk_pickup_day);
    } else {
      _array.push('');
    }
    if (element.tax) {
      _array.push(element.tax);
    } else {
      _array.push(10);
    }

    let toast = this.toastCtrl.create({
      message: this.translate.instant('general-articulo') + ' ' + this.globals.nameLangSelectDish(element) + ' ' + this.translate.instant('instant-anadido-correctemente'),
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
    //Hacemos push al listado de elementos seleccionados
    this.cartaServices.carta_dish_prod_array_tmp.push(_array);
    this.cartaServices.carta_dish_prod_array_tmp = [...this.cartaServices.carta_dish_prod_array_tmp];
    //Hacemos push al listado de todos los elementos
    this.cartaServices.products_dishes_array.push(element);
    this.cartaServices.products_dishes_array = [...this.cartaServices.products_dishes_array];

    this.analyticsServices.trackingExp('entrar plato a carta', this.globals.tracking_exp['insert_element_menu'], '');
  }

  insertToMenu(element, element_uid) {
    element.UID = element_uid;
    element.name = element.name_es;
    element.type = 'dish';

    var _array = Array();
    _array.push(element.UID); //UID
    _array.push(this.menuServices.menu_dish_array_tmp.length + 1); //Order
    _array.push(element.name_es);
    _array.push(element.name_ca);
    _array.push(element.name_en);
    _array.push(element.name_de);
    _array.push(element.name_fr);
    _array.push(element.name_it);
    if (element.allergens) {
      _array.push(element.allergens);
    } else {
      _array.push([]);
    }
    if (element.foodcost_static) {
      _array.push(element.foodcost_static);
    } else {
      _array.push(0);
    }
    if (element.foodcost_parts) {
      _array.push(element.foodcost_parts);
    } else {
      _array.push(0);
    }
    _array.push('dish');
    _array.push(element.price);
    if (element.price_combo_extra) {
      _array.push(element.price_combo_extra);
    } else {
      _array.push(0);
    }
    if (element.price_takeaway) {
      _array.push(element.price_takeaway);
    } else {
      _array.push(0);
    }
    _array.push(element.description_es);
    _array.push(element.description_ca);
    _array.push(element.description_en);
    _array.push(element.description_de);
    _array.push(element.description_fr);
    _array.push(element.description_it);

    _array.push(element.tags);

    if (element.price_supplement) {
      _array.push(element.price_supplement);
    } else {
      _array.push(0);
    }

    let toast = this.toastCtrl.create({
      message: this.translate.instant('general-plato') + ' ' + this.globals.nameLangSelectDish(element) + ' ' + this.translate.instant('instant-anadido-correctemente'),
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
    //Hacemos push al listado de elementos seleccionados
    this.menuServices.menu_dish_array_tmp.push(_array);
    this.menuServices.menu_dish_array_tmp = [...this.menuServices.menu_dish_array_tmp];
    //Hacemos push al listado de todos los elementos
    this.menuServices.products_dishes_array.push(element);
    this.menuServices.products_dishes_array = [...this.menuServices.products_dishes_array];

    this.analyticsServices.trackingExp('entrar plato a menu', this.globals.tracking_exp['insert_element_menu'], '');
  }

  insertToCombo(element, element_uid) {
    element.UID = element_uid;
    element.name = element.name_es;
    element.type = 'dish';

    var _array = Array();
    _array.push(element.UID); //UID
    _array.push(this.menuServices.menu_dish_array_tmp.length + 1); //Order
    _array.push(element.name_es);
    _array.push(element.name_ca);
    _array.push(element.name_en);
    _array.push(element.name_de);
    _array.push(element.name_fr);
    _array.push(element.name_it);
    if (element.allergens) {
      _array.push(element.allergens);
    } else {
      _array.push([]);
    }
    if (element.foodcost_static) {
      _array.push(element.foodcost_static);
    } else {
      _array.push(0);
    }
    if (element.foodcost_parts) {
      _array.push(element.foodcost_parts);
    } else {
      _array.push(0);
    }
    _array.push(element.type);
    _array.push(element.price);
    if (element.price_combo_extra) {
      _array.push(element.price_combo_extra);
    } else {
      _array.push(0);
    }
    if (element.price_takeaway) {
      _array.push(element.price_takeaway);
    } else {
      _array.push(0);
    }
    _array.push(element.description_es);
    _array.push(element.description_ca);
    _array.push(element.description_en);
    _array.push(element.description_de);
    _array.push(element.description_fr);
    _array.push(element.description_it);

    _array.push(element.tags);

    if (element.image) {
      _array.push(element.image);
    } else {
      _array.push('');
    }

    let toast = this.toastCtrl.create({
      message: this.translate.instant('general-plato') + ' ' + this.globals.nameLangSelectDish(element) + ' ' + this.translate.instant('instant-anadido-correctemente'),
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
    //Hacemos push al listado de elementos seleccionados
    this.menuServices.menu_dish_array_tmp.push(_array);
    this.menuServices.menu_dish_array_tmp = [...this.menuServices.menu_dish_array_tmp];
    //Hacemos push al listado de todos los elementos
    this.menuServices.products_dishes_array.push(element);
    this.menuServices.products_dishes_array = [...this.menuServices.products_dishes_array];

    this.analyticsServices.trackingExp('entrar plato a combo', this.globals.tracking_exp['insert_element_menu'], '');
  }

  insertToCartaTK(element, element_uid) {
    element.UID = element_uid;
    element.name = element.name_es;
    element.type = 'dish';
    this.odsServices.list_elements.push(element);
    this.odsServices.list_elements = [...this.odsServices.list_elements];
    this.odsServices.selected_elements.push(element);
    //trackingPLGPedidos
    this.analyticsServices.trackingExpPedidos('add_article', this.globals.tracking_exp['insert_element_menu']);
  }

  selectToCreateVariation(element, element_uid) {
    element.UID = element_uid;
    this.viewCtrl.dismiss(element);
  }

}


// WEBPACK FOOTER //
// ./src/pages/components/popups/create-dish/create-dish.ts